import { Icon } from '@shopify/polaris';
import { ExternalSmallIcon } from '@shopify/polaris-icons';
import { memo } from 'react';
import { Link, LinkProps } from 'react-router-dom';
import { StyledExternalLink } from './styled';

const ExternalLink = ({ ...props }: LinkProps) => {
  return (
    <StyledExternalLink>
      <Link
        target="_blank"
        rel="noopener noreferrer"
        className="text-link-external"
        onClick={(e) => e.stopPropagation()}
        {...props}
      />
      <Icon source={ExternalSmallIcon} />
    </StyledExternalLink>
  );
};

export default memo(ExternalLink);
